import { render, staticRenderFns } from "./WxCarSearchDetailed.vue?vue&type=template&id=bfbd2190&scoped=true&"
import script from "./WxCarSearchDetailed.vue?vue&type=script&lang=js&"
export * from "./WxCarSearchDetailed.vue?vue&type=script&lang=js&"
import style0 from "./WxCarSearchDetailed.vue?vue&type=style&index=0&id=bfbd2190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbd2190",
  null
  
)

export default component.exports